module.exports = __webpack_public_path__ + "img/banner7.ff36cecd.jpg";